"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _extrablockUtils = _interopRequireDefault(require("../util/extrablockUtils"));
require("../playground/blocks/block_ai_utilize_audio");
require("../playground/blocks/block_ai_utilize_tts");
require("../playground/blocks/block_ai_utilize_translate");
require("../playground/blocks/block_ai_utilize_video");
require("../playground/blocks/block_ai_utilize_gesture_recognition");
require("../playground/blocks/block_ai_utilize_pose_landmarker");
require("../playground/blocks/block_ai_utilize_face_landmarker");
require("../playground/blocks/block_ai_utilize_object_detector");
var AIUtilize = exports["default"] = /*#__PURE__*/function () {
  function AIUtilize(playground) {
    (0, _classCallCheck2["default"])(this, AIUtilize);
    this.playground = playground;
  }
  return (0, _createClass2["default"])(AIUtilize, [{
    key: "init",
    value: function init() {
      var blockObject = {};
      Object.entries(Entry.AI_UTILIZE_BLOCK).forEach(function (_ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (key === 'video') {
          Entry.AI_UTILIZE_BLOCK_LIST_DEPRECATED.video = value;
        } else {
          Entry.AI_UTILIZE_BLOCK_LIST[key] = value;
        }
        Entry.ALL_AI_UTILIZE_BLOCK_LIST[key] = value;
        if ('getBlocks' in value) {
          (0, _extends2["default"])(blockObject, value.getBlocks());
        }
      });
      Entry.block = (0, _extends2["default"])(Entry.block, blockObject);
    }
  }, {
    key: "banAllAIUtilizeBlock",
    value: function banAllAIUtilizeBlock() {
      _extrablockUtils["default"].banAllBlocks(this.playground, Entry.ALL_AI_UTILIZE_BLOCK_LIST);
    }
  }, {
    key: "banAIUtilizeBlocks",
    value: function banAIUtilizeBlocks() {
      var aiUtilizeNames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      _extrablockUtils["default"].banBlocks(aiUtilizeNames, Entry.ALL_AI_UTILIZE_BLOCK_LIST, function (aiUtilizeTypes) {
        return Entry["do"]('objectRemoveAIUtilizeBlocks', aiUtilizeTypes).isPass(true);
      });
    }
  }, {
    key: "isActive",
    value: function isActive(aiUtilizeName) {
      return _extrablockUtils["default"].isActive(aiUtilizeName, Entry.ALL_AI_UTILIZE_BLOCK_LIST);
    }
  }, {
    key: "addAIUtilizeBlocks",
    value: function addAIUtilizeBlocks(blockNames) {
      Entry["do"]('objectAddAIUtilizeBlocks', blockNames);
    }
  }, {
    key: "getAIUtilizes",
    value: function getAIUtilizes(blockList) {
      return _extrablockUtils["default"].getExtras(blockList, 'category_ai_utilize');
    }
  }, {
    key: "destroy",
    value: function destroy() {
      // 우선 interface 만 정의함.
    }
  }]);
}();